<script setup>
import packageFile from '../../package.json'

const yearToday = new Date().toISOString().substring(0, 4)
</script>

<template>
  <div class="pt-4 pb-3" />
  <div
    class="position-fixed bottom-0 bg-light w-100 d-flex justify-content-between container-fluid small pt-1
   text-nowrap gap-3"
  >
    <div>
      Hobby ManTester v. {{ packageFile.version }}
    </div>
    <div>
      © 2021-{{ yearToday }}
      <a
        href="https://Lastware.cz/"
        target="_blank"
        class="text-dark"
      >
        lastware.cz
      </a>
    </div>
  </div>
</template>
